import dayjs, { Dayjs } from "dayjs";

export function formatDateTime(date: Dayjs): string {
  const dateTimeFormatted = date.format("YYYY-MM-DD HH:mm:ss");

  return dateTimeFormatted;
}

export function getDateTime(date: Dayjs, time: Dayjs): Dayjs {
  const dateFormatted = date.format("YYYY-MM-DD");
  const timeFormatted = time.format("HH:mm:ss");
  const dateTimeFormatted = `${dateFormatted} ${timeFormatted}`;
  const dateTime = dayjs(dateTimeFormatted);

  return dateTime;
}
